import { render } from "./Results.vue?vue&type=template&id=70e0d663&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=70e0d663&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70e0d663"

export default script